// NodeList.forEach
if ( window.NodeList && !NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = function ( callback, thisArg ) {
		thisArg = thisArg || window;
		for ( var i = 0; i < this.length; i++ ) {
			callback.call( thisArg, this[ i ], i, this );
		}
	};
}

// Element.closest
if ( !Element.prototype.matches ) {
	Element.prototype.matches = Element.prototype.msMatchesSelector ||
		Element.prototype.webkitMatchesSelector;
}

if ( !Element.prototype.closest ) {
	Element.prototype.closest = function ( s ) {
		var el = this;

		do {
			if ( el.matches( s ) ) return el;
			el = el.parentElement || el.parentNode;
		} while ( el !== null && el.nodeType === 1 );
		return null;
	};
}

// String.startsWith
if ( !String.prototype.startsWith ) {
	Object.defineProperty( String.prototype, 'startsWith', {
		value: function ( search, rawPos ) {
			var pos = rawPos > 0 ? rawPos | 0 : 0;
			return this.substring( pos, pos + search.length ) === search;
		}
	} );
}
